import React, { useContext, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSearchParams } from 'react-router-dom';
import { Context as AuthContext } from '../../../providers/AuthContextProvider';
import CustomSelect from '../../common/CustomSelect';

const VendorSelectInput = ({
  label,
  value,
  onChange,
  autoPopulate,
  placeholder,
  data,
  disabled,
  ...rest
}) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const { state, selectEcomVendor } = useContext(AuthContext);
  const pkEcomVendorParam = searchParams.get('vendor') || state.pkEcomVendor;
  const ecomVendorOptions =
    data ??
    state.ecomVendors
      .sort((a, b) => a.name.localeCompare(b.name))
      .map((a) => ({
        forceImage: true,
        image: a.logoImageUrl,
        value: a.pkEcomVendor.toString(),
        label: a.name
      }));

  const selectValue = onChange ? value : state.pkEcomVendor?.toString();

  useEffect(() => {
    const pkEcomVendor =
      (
        state.ecomVendors.find(
          (a) => a.pkEcomVendor.toString() === pkEcomVendorParam.toString()
        )?.value ?? ecomVendorOptions[0]?.value
      )?.toString() ?? '';
    if (!selectValue && autoPopulate && pkEcomVendor) {
      if (onChange) {
        onChange(pkEcomVendor);
      }
      else {
        selectEcomVendor(pkEcomVendor);
      }
    }
  }, [pkEcomVendorParam, state.loading]);

  return (
    <CustomSelect
      data={ecomVendorOptions}
      disabled={disabled || state.loading}
      label={label}
      onChange={(v) => {
        if (onChange) {
          onChange(v);
        }
        else {
          const ecomVendor = state.ecomVendors.find(
            (a) => a.pkEcomVendor.toString() === v
          );
          selectEcomVendor(ecomVendor?.pkEcomVendor?.toString());
        }
      }}
      placeholder={placeholder ?? 'Filter by vendor'}
      value={selectValue}
      {...rest}
    />
  );
};

VendorSelectInput.propTypes = {
  autoPopulate: PropTypes.bool,
  data: PropTypes.array,
  disabled: PropTypes.bool,
  isDisabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  label: PropTypes.string,
  onChange: PropTypes.func,
  placeholder: PropTypes.string,
  value: PropTypes.string
};

export default VendorSelectInput;
